<div class='indicator-container'>
  <app-portal-data-element-list-indicator-element-container>
    <app-portal-data-element-list-indicator-element
      *ngIf='portalDataIndicatorData["product"]'
      itemName='Product'
      [nbCompleted]='portalDataIndicatorData["product"].nbCompleted'
      [nbNotCompleted]='portalDataIndicatorData["product"].nbNotCompleted'
    >
    </app-portal-data-element-list-indicator-element>
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container>
    <app-portal-data-element-list-indicator-element
      *ngIf='portalDataIndicatorData["diagnosisScenario"]'
      itemName='Diagnosis Scenarios'
      [nbCompleted]='portalDataIndicatorData["diagnosisScenario"].nbCompleted'
      [nbNotCompleted]='portalDataIndicatorData["diagnosisScenario"].nbNotCompleted'
    >
    </app-portal-data-element-list-indicator-element>
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container>
    <app-portal-data-element-list-indicator-element
      *ngIf='portalDataIndicatorData["inStoreService"]'
      itemName='In-Store services'
      [nbCompleted]='portalDataIndicatorData["inStoreService"].nbCompleted'
      [nbNotCompleted]='portalDataIndicatorData["inStoreService"].nbNotCompleted'
    >
    </app-portal-data-element-list-indicator-element>
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container>
    <app-portal-data-element-list-indicator-element
      *ngIf='portalDataIndicatorData["sample"]'
      itemName='Sample'
      [nbCompleted]='portalDataIndicatorData["sample"].nbCompleted'
      [nbNotCompleted]='portalDataIndicatorData["sample"].nbNotCompleted'
    >
    </app-portal-data-element-list-indicator-element>
  </app-portal-data-element-list-indicator-element-container>
  <app-portal-data-element-list-indicator-element-container>
    <app-portal-data-element-list-indicator-element
      *ngIf='portalDataIndicatorData["gesture"]'
      itemName='Gesture'
      [nbCompleted]='portalDataIndicatorData["gesture"].nbCompleted'
      [nbNotCompleted]='portalDataIndicatorData["gesture"].nbNotCompleted'
    >
    </app-portal-data-element-list-indicator-element>
  </app-portal-data-element-list-indicator-element-container>
</div>
